import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import {UserAction} from "../actions/UserAction"
import {SearchAction} from "../actions/SearchAction"
import classnames from 'classnames'
import {Container} from "reactstrap"
import femaleAvatar from '../assets/img/female-avatar.png'
import maleAvatar from '../assets/img/male-avatar.png'
import entityAvatar from '../assets/img/entity-avatar.png'
import emptyAvatar from '../assets/img/empty-avatar.png'
import $ from "jquery"
import CustomLi from "./CustomLi"
import i18n from "i18next"
import CustomImage from "./CustomImage"
import {ACTIVE_TAB, gaEventWithUserIdLabel, izEmpty, izNotBlank, sourceFlag} from "../constants";
import LinkPreview from "./LinkPreview";
import Relations from "./Relations";

class SearchCard extends Component {

    constructor(props) {
        super(props);

        ['toggleActiveTab'].forEach((method) => this[method] = this[method].bind(this))
    }

    toggleActiveTab(tab, e) {

        e.preventDefault()

        this.props.searchAction(ACTIVE_TAB, tab)

        if ($(window).innerWidth() < 767) {
            $('html, body').animate({
                scrollTop: $("#search-result-tab-content").offset().top - 51
            }, 1000)
        }

        gaEventWithUserIdLabel("SearchCard toggleActiveTab Click - " + tab)
    }

    clearPlaceHolder(clonedDoc, givenName) {
        clonedDoc.querySelector('input[name=' + givenName + ']').setAttribute('placeholder', '')
    }

    render() {

        const searchResultData = this.props.search
        const {searchResults, activeTab} = searchResultData

        if (izEmpty(searchResults)) return ""

        let activeRecord = searchResults[activeTab]

        let recordType = activeRecord.recordType

        let matchRate = activeRecord.matchRate;

        let programs = activeRecord.programs ? activeRecord.programs.map(function (item) {
                return item.name ? item.name : item.comment
            }).join(" - ")
            : ""

        let fullName = activeRecord.nameAliases ? activeRecord.nameAliases.filter(n => n.type === "name")[0].wholeName
            : ""

        let sourceFullName = activeRecord.sourceFullName[this.props.common.lang]

        let gender = activeRecord.gender
        let isIndividual = recordType === "individual";
        let isEntity = recordType === "entity";

        let externalAvatar = activeRecord.avatarUrl
        let avatar = isIndividual
            ?
            gender === "F"
                ? femaleAvatar
                : (gender === "M" ? maleAvatar : emptyAvatar)
            : entityAvatar

        let placeOfBirths = activeRecord.locations ? activeRecord.locations.filter(n => n.type === "placeofbirth").map(function (item) {
                return item.wholePlace;
            }).join(" - ")
            : ""

        let dateOfBirths = activeRecord.birthdates ? activeRecord.birthdates.map(function (item) {
                return item.date
            }).join(" - ")
            : ""

        let citizenships = activeRecord.locations ? activeRecord.locations.filter(n => n.type === "citizenship").map(function (item) {
                return item.wholePlace;
            }).join(" - ")
            : ""

        let nationalities = activeRecord.locations ? activeRecord.locations.filter(n => n.type === "nationality").map(function (item) {
                return item.wholePlace
            }).join(" - ")
            : ""

        let remark = activeRecord.remark

        let akas = activeRecord.nameAliases.filter(n => n.type === "aka").map(function (item) {
            return item.wholeName
        }).join(" - ")

        let passports = activeRecord.identifications ? activeRecord.identifications
                .filter(i => i.number)
                .map(function (item) {
                    let desc = item.identificationTypeDescription ? item.identificationTypeDescription : ""
                    let city = item.city ? item.city : ""
                    let countryAndCity = item.country ? (city !== "" ? city + ", " + item.country : item.country) : city
                    let countryAndCityAndDesc = countryAndCity !== "" ? countryAndCity + (desc !== "" ? " - " + desc : "") : desc
                    let remark = item.remark ? item.remark : ""

                    return item.number + (izNotBlank(countryAndCityAndDesc)
                        ? " (" + countryAndCityAndDesc + (izNotBlank(remark) ? " - " + remark : "") + ")"
                        : (izNotBlank(remark) ? "(" + remark + ")" : ""));
                }).join(" - ")
            : ""

        let addresses = activeRecord.locations ? activeRecord.locations.filter(n => n.type === "address").map(function (item) {
                return item.wholePlace;
            }).join(" - ")
            : ""

        let adverseMedias = activeRecord.mediaLinks ? activeRecord.mediaLinks : [];
        let relations = activeRecord.relations ? activeRecord.relations : [];

        return (
            <>
                {!!searchResults.length &&
                    <section className="">
                        <Container>
                            <div className="search-result-tab custom-card-border justify-content-center">
                                <ul className="nav">
                                    {searchResults.map((row, index) => {
                                        const source = row.source;
                                        const enteredFlag = row.flag

                                        // console.log(enteredFlag);
                                        const sourceShortName = row.sourceShortName[this.props.common.lang]

                                        const wholeName = row.nameAliases.filter(n => n.type === "name")[0].wholeName;
                                        const matchRate = row.matchRate;
                                        const matchRateDesc = matchRate && 60 <= matchRate ? " (" + matchRate + "%)" : "";

                                        return (
                                            <li key={index} className="nav-pills">
                                                <a className={classnames({active: index === activeTab}, "nav-link d-flex justify-content-start")}
                                                   id={"nav-link-" + index} data-toggle="pill" href={"#search-result-tab-content"}
                                                   onClick={(e) => {
                                                       this.toggleActiveTab(index, e)
                                                   }}>

                                                    <div className="source-img">
                                                        <img src={sourceFlag(source, enteredFlag)} width="30" alt="Search Sanctions AML Solutions"/>
                                                    </div>

                                                    <div className="nav-link-title">
                                                        <h5>{sourceShortName + matchRateDesc}</h5>
                                                        <p className="whole-name">{wholeName}</p>
                                                        {/*<p className="tab-score">{i18n.t('score')}: {row.matchRate}</p>*/}
                                                    </div>
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>

                                <div className="row search-result-tab-content" id="search-result-tab-content">
                                    <div className="col-sm-12 col-md-2 content-img">
                                        <ul>
                                            <li>
                                                {externalAvatar && externalAvatar !== ""
                                                    ?
                                                    <CustomImage className="circled-img" key={externalAvatar} src={externalAvatar} emptyAvatar={emptyAvatar}/>
                                                    :
                                                    <img className="circled-img" key={"internal"} src={avatar} alt=""/>
                                                }
                                            </li>
                                            {programs && programs !== ""
                                                ?
                                                <>
                                                    <li className="pt-15">
                                                        <strong>{i18n.t('program')}</strong>
                                                    </li>
                                                    <li>
                                                        <span>{programs}</span>
                                                    </li>
                                                </>
                                                :
                                                <></>
                                            }
                                            {matchRate
                                                ?
                                                <>
                                                    <li className="pt-15">
                                                        <strong className="p-0">{i18n.t('matchRate')}</strong>
                                                    </li>
                                                    <li>
                                                        <span>{matchRate + "%"}</span>
                                                    </li>
                                                </>
                                                :
                                                <></>
                                            }
                                        </ul>
                                    </div>
                                    <div className="col-sm-12 col-md-10 content-detail">
                                        <ul>
                                            <CustomLi title={i18n.t('list_name')} detail={sourceFullName}/>
                                            <CustomLi title={isIndividual ? i18n.t('person_name') : (isEntity ? i18n.t('entity_name') : i18n.t('country_name'))}
                                                      detail={fullName}/>
                                            <CustomLi title={i18n.t('gender')}
                                                      detail={i18n.t('gender_' + gender)}
                                                      hide={isIndividual === false || !gender || gender !== "M" || gender !== "F"}/>
                                            <CustomLi title={i18n.t('place_of_birth')} detail={placeOfBirths}/>
                                            <CustomLi title={i18n.t('date_of_birth')} detail={dateOfBirths}/>
                                            <CustomLi title={i18n.t('citizenship')} detail={citizenships}/>
                                            <CustomLi title={i18n.t('nationality')} detail={nationalities}/>
                                            <CustomLi title={i18n.t('akas')} detail={akas}/>
                                            <CustomLi title={i18n.t('passport_details')} detail={passports}/>
                                            <CustomLi title={i18n.t('addresses')} detail={addresses}/>
                                            <CustomLi title={i18n.t('other_infos')} detail={remark}/>

                                            <Relations title={i18n.t('relations')} relations={relations}/>

                                            {!!adverseMedias.length &&
                                                <li>
                                                    <div className="row justify-content-center mb-20">
                                                        <div className="col-12 text-center mt-10">
                                                            <strong>{i18n.t('adverseMedias')} </strong>
                                                            <label className="adverse-media-warn">{i18n.t('adverseMedias_warn')} </label>
                                                        </div>

                                                        <div className="col-12">
                                                            {adverseMedias.map((adverseMedia, index) => {
                                                                let {link, title, siteName, image} = adverseMedia;

                                                                return <LinkPreview order={index}
                                                                                    key={index}
                                                                                    link={link}
                                                                                    title={title}
                                                                                    siteName={siteName}
                                                                                    image={image}/>;
                                                            })}
                                                        </div>
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </section>
                }
            </>
        )
    }

}

function mapStateToProps(state) {

    return {
        common: state.common,
        user: state.user,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        searchAction: SearchAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchCard);